import script from "./PageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=0d7ea492&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\winkk\\Downloads\\交接\\20261021\\nsr-isso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7ea492"]])

export default __exports__